import useWindowDimensions from "helpers/screen";
import ButtonSelector from "../ButtonSelector";
import ChangeIndicator from "../ChangeIndicator";
import CryptoIcon from "../CryptoIcon";
import "./style.scss";

const EcosystemOverview = ({}) => {

  const {width} = useWindowDimensions();
  
  return <div className="ecosystemOverview">
    <div className="timeFrameSelector justify-between">
      <p className="title">Top Gainers</p>
      <ButtonSelector items={[
          "24h", "7d", "30d"
        ]}
        selected={0}
      />
    </div>
    <div className="sectionWrapper">
      <div className="section">
        
        {
          [0,0,0,0,0].map((item, i) => {
              return <div className="item">
                <div className="side">
                  <CryptoIcon symbol="PRISM"/>
                  <div className="info">
                    <p className="name">Prism</p>
                    <p className="symbol">PRISM</p>
                  </div>
                </div>
                <div className="side">
                  <div className="prices">
                    <p className="price">$0.0931</p>
                    <ChangeIndicator change={{percentage: 1.30}} showFull={false}/>
                  </div>
                </div>
              </div>
            })
          }
      </div>

      <div className="section">
        <div className="topLosers justify-between">
          <p className="title">Top Losers</p>
        </div>
        {
          [0,0,0,0,0].map((item, i) => {
              return <div className="item">
                <div className="side">
                  <CryptoIcon symbol="PRISM"/>
                  <div className="info">
                    <p className="name">Prism</p>
                    <p className="symbol">PRISM</p>
                  </div>
                </div>
                <div className="side">
                  <div className="prices">
                    <p className="price">$0.0931</p>
                    <ChangeIndicator change={{percentage: -1.30}} showFull={false}/>
                  </div>
                </div>
              </div>
            })
          }
      </div>
    </div>
    
  </div>
}

export default EcosystemOverview;